import { Phone, MessageCircle, User, Clock } from "lucide-react";

export default function Contact() {
  return (
    <section
      id="contact"
      className="relative bg-blue-700 text-white py-20 lg:py-28 overflow-hidden"
      data-testid="contact-section"
    >
      {/* decorative shapes */}
      <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-orange-500/20 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-white/10 blur-3xl" />

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-sm font-bold uppercase tracking-[0.2em] text-orange-300">
          Boek nu
        </p>
        <h2 className="font-display font-bold mt-3 text-4xl sm:text-6xl tracking-tight leading-[1.05]">
          Interesse?{" "}
          <span className="text-orange-400">Boek nu.</span>
          <br />
          Want vol is vol.
        </h2>
        <p className="mt-6 text-lg text-blue-100 max-w-2xl mx-auto">
          Wij plannen op volgorde van binnenkomst. Neem direct contact op met
          De Toiletman voor een vrijblijvende afspraak en gratis offerte aan huis.
        </p>

        <div className="mt-12 grid sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-2xl p-5 text-left" data-testid="contact-card-person">
            <User className="w-5 h-5 text-orange-300" />
            <div className="mt-3 text-xs uppercase tracking-widest text-blue-200 font-semibold">Contactpersoon</div>
            <div className="mt-1 font-display font-bold text-2xl">De Toiletman</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-2xl p-5 text-left" data-testid="contact-card-phone">
            <Phone className="w-5 h-5 text-orange-300" />
            <div className="mt-3 text-xs uppercase tracking-widest text-blue-200 font-semibold">Bel direct</div>
            <a href="tel:+31615460576" className="mt-1 block font-display font-bold text-2xl hover:text-orange-300 transition-colors">
              06 154 60 576
            </a>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-2xl p-5 text-left" data-testid="contact-card-availability">
            <Clock className="w-5 h-5 text-orange-300" />
            <div className="mt-3 text-xs uppercase tracking-widest text-blue-200 font-semibold">Bereikbaar</div>
            <div className="mt-1 font-display font-bold text-2xl">Ma–Za 08–20u</div>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="tel:+31615460576"
            className="inline-flex items-center justify-center gap-2 h-14 px-8 rounded-full bg-white text-blue-700 hover:bg-slate-100 font-semibold transition-colors"
            data-testid="contact-call-btn"
          >
            <Phone className="w-5 h-5" />
            Bel 06 154 60 576
          </a>
          <a
            href="https://wa.me/31615460576?text=Hoi%2C%20ik%20wil%20graag%20info%20over%20een%20toiletrenovatie."
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 h-14 px-8 rounded-full bg-orange-500 hover:bg-orange-600 text-white font-semibold transition-colors"
            data-testid="contact-whatsapp-btn"
          >
            <MessageCircle className="w-5 h-5" />
            WhatsApp De Toiletman
          </a>
        </div>
      </div>
    </section>
  );
}
